<div class="dialog-content">
  <!--title 標題-->
  <h1
    class="dialog-title"
    [innerHTML]="'forgot-password-dialog.title' | translate"
  ></h1>

  <!--subtitle 標題-->
  <p class="dialog-subtitle">
    {{ 'forgot-password-dialog.message' | translate }}
  </p>
  <!--btn:關閉按鈕-->
  <button mat-button class="dialog-close-btn" (click)="closeDialog()">
    <img src="assets/img/i-close.svg" alt="" />
  </button>

  <!--dialog 內容-->
  <form
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="onSubmit()"
    class="dialog-form"
  >
    <div class="input-block">
      <label class="input-title input-text-required" for="birthday">{{
        'forgot-password-dialog.birthday' | translate
      }}</label>
      <div class="birthday-group">
        <div
          class="birthday-field"
          [ngClass]="{ 'input-error': isYearInvalid || showBirthdayEmptyError }"
        >
          <input
            id="birthday"
            type="tel"
            inputmode="numeric"
            appNumericOnly
            maxlength="4"
            class="birthday-input"
            [placeholder]="'reserve-info.birthday-year' | translate"
            [(ngModel)]="birthYear"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBirthdayPartChange(); autoFocusNext('year', monthInput)"
          />
          <span class="birthday-unit">{{ 'reserve-info.year-unit' | translate }}</span>
        </div>
        <div
          class="birthday-field birthday-field-sm"
          [ngClass]="{ 'input-error': isMonthInvalid || showBirthdayEmptyError }"
        >
          <input
            #monthInput
            type="tel"
            inputmode="numeric"
            appNumericOnly
            maxlength="2"
            class="birthday-input"
            [placeholder]="'reserve-info.birthday-month' | translate"
            [(ngModel)]="birthMonth"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBirthdayPartChange(); autoFocusNext('month', dayInput)"
          />
          <span class="birthday-unit">{{ 'reserve-info.month-unit' | translate }}</span>
        </div>
        <div
          class="birthday-field birthday-field-sm"
          [ngClass]="{ 'input-error': isDayInvalid || showBirthdayEmptyError }"
        >
          <input
            #dayInput
            type="tel"
            inputmode="numeric"
            appNumericOnly
            maxlength="2"
            class="birthday-input"
            [placeholder]="'reserve-info.birthday-day' | translate"
            [(ngModel)]="birthDay"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onBirthdayPartChange()"
          />
          <span class="birthday-unit">{{ 'reserve-info.day-unit' | translate }}</span>
        </div>
      </div>
      @if (showBirthdayEmptyError) {
        <mat-error class="input-error-msg">{{
          'error.birthday-error.year' | translate
        }}</mat-error>
      } @else if (isYearInvalid) {
        <mat-error class="input-error-msg">{{
          'error.birthday-error.year' | translate
        }}</mat-error>
      } @else if (isMonthInvalid) {
        <mat-error class="input-error-msg">{{
          'error.birthday-error.month' | translate
        }}</mat-error>
      } @else if (isDayInvalid) {
        <mat-error class="input-error-msg">{{
          'error.birthday-error.day' | translate
        }}</mat-error>
      } @else if (
        (showErrorMessage || birthdayFilled) && forgotPasswordForm.get('birthday')?.invalid
      ) {
        <mat-error class="input-error-msg">{{
          getBirthdayErrorMessage()
        }}</mat-error>
      }
    </div>
    <div class="input-block">
      <label class="input-title input-text-required" for="idNumber">{{
        'forgot-password-dialog.idNumber' | translate
      }}</label>
      <input
        id="idNumber"
        appAlphaNumericOnly
        matInput
        type="text"
        formControlName="idNumber"
        [placeholder]="
          'forgot-password-dialog.idNumber-placeholder' | translate
        "
        [ngClass]="{
          'input-error':
            showErrorMessage && forgotPasswordForm.get('idNumber')?.invalid,
        }"
        [maxLength]="idNumberMaxLength"
      />
      @if (showErrorMessage && forgotPasswordForm.get('idNumber')?.invalid) {
        <mat-error class="input-error-msg">{{
          getIdNumberErrorMessage()
        }}</mat-error>
      }
    </div>
    <button mat-button type="submit" class="btn-fill-primary btn-size-l">
      {{ 'forgot-password-dialog.send-otp' | translate }}
    </button>
  </form>
</div>
